module.exports = __webpack_public_path__ + "static/img/victoria1.c81e495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/victoria1.jpg
// module id = 147
// module chunks = 9